import React from "react";

const RhymesTab = ({
  rhymeResults,
  rhymeLoading,
  rhymeQuery,
  onSearchInLyrics,
}) => {
  return (
    <div>
      {rhymeLoading && (
        <div className="text-center py-8 text-forest-300">
          Finding rhymes...
        </div>
      )}

      {rhymeResults && (
        <div className="space-y-6">
          <div className="rounded-lg border p-6 transition-colors bg-forest-800 border-forest-600">
            <h3 className="text-lg font-semibold mb-4 text-forest-100">
              Perfect Rhymes for "{rhymeQuery}"
            </h3>
            {rhymeResults.perfect.length > 0 ? (
              <div className="flex flex-wrap gap-2">
                {rhymeResults.perfect.map((word, index) => (
                  <button
                    key={index}
                    onClick={() => onSearchInLyrics(word.word, "dictionary")}
                    className="px-3 py-1 rounded-full text-sm transition-colors bg-gold-500 hover:bg-gold-400 text-forest-900"
                  >
                    {word.word}
                  </button>
                ))}
              </div>
            ) : (
              <p className="text-forest-300">No perfect rhymes found</p>
            )}
          </div>

          <div className="rounded-lg border p-6 transition-colors bg-forest-800 border-forest-600">
            <h3 className="text-lg font-semibold mb-4 text-forest-100">
              Near Rhymes for "{rhymeQuery}"
            </h3>
            {rhymeResults.near.length > 0 ? (
              <div className="flex flex-wrap gap-2">
                {rhymeResults.near.map((word, index) => (
                  <button
                    key={index}
                    onClick={() => onSearchInLyrics(word.word, "dictionary")}
                    className="px-3 py-1 rounded-full text-sm transition-colors bg-leaf-500 hover:bg-leaf-400 text-forest-900"
                  >
                    {word.word}
                  </button>
                ))}
              </div>
            ) : (
              <p className="text-forest-300">No near rhymes found</p>
            )}
          </div>

          <div className="rounded-lg border p-6 transition-colors bg-forest-800 border-forest-600">
            <h3 className="text-lg font-semibold mb-4 text-forest-100">
              Sounds Like "{rhymeQuery}"
            </h3>
            {rhymeResults.soundsLike.length > 0 ? (
              <div className="flex flex-wrap gap-2">
                {rhymeResults.soundsLike.map((word, index) => (
                  <button
                    key={index}
                    onClick={() => onSearchInLyrics(word.word, "dictionary")}
                    className="px-3 py-1 rounded-full text-sm transition-colors bg-gold-500 hover:bg-gold-400 text-forest-900"
                  >
                    {word.word}
                  </button>
                ))}
              </div>
            ) : (
              <p className="text-forest-300">No similar sounding words found</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default RhymesTab;
